import React from 'react';
import Styles from './daily-earnings-styles.scss';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
const DailyEarnings = ({ title = 'Daily Earnings', values = [], dates = [] }) => {
    ChartJS.register(CategoryScale, LinearScale, BarElement, ChartDataLabels, Title, Legend);
    ChartJS.defaults.datasets.bar.barThickness = 30;
    const parseDates = () => {
        const labels = dates.map(date => {
            const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(new Date(date));
            const day = new Date(date).getDate();
            return [month, day];
        });
        return labels;
    };
    const data = {
        labels: parseDates(),
        datasets: [
            {
                label: 'Dataset 1',
                data: values,
                backgroundColor: '#89C900'
            }
        ]
    };
    return (React.createElement("div", { className: Styles.dailyEarningsContainer },
        React.createElement("div", { className: Styles.title },
            React.createElement("h3", null, "Daily Earnings")),
        React.createElement("div", { className: Styles.bar },
            React.createElement(Bar, { options: {
                    responsive: true,
                    scales: {
                        y: {
                            border: {
                                dash: [5, 10],
                                width: 1,
                                color: 'white'
                            },
                            beginAtZero: true,
                            ticks: {
                                padding: 25,
                                callback: function (value, index, ticks) {
                                    const addCommas = (x) => {
                                        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                    };
                                    return `$ ${addCommas(Number(value))}`;
                                },
                                color: '#999',
                                font: {
                                    size: 12
                                }
                            }
                        },
                        x: {
                            border: {
                                color: 'transparent'
                            },
                            grid: {
                                display: false,
                                drawOnChartArea: false
                            },
                            ticks: {
                                color: '#999',
                                font: {
                                    size: 12
                                }
                            }
                        }
                    },
                    plugins: {
                        title: {
                            display: false
                        },
                        legend: {
                            display: false
                        },
                        datalabels: {
                            offset: (context) => {
                                context.chart.legend.top = -150;
                                return null;
                            },
                            formatter: function (value, context) {
                                const addCommas = (x) => {
                                    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                };
                                if (Number(value) === 0)
                                    return '';
                                return `$ ${addCommas(Number(value))}`;
                            },
                            align: 'end',
                            anchor: 'end',
                            color: '#89C900',
                            font: {
                                size: 12,
                                weight: 600
                            }
                        }
                    }
                }, data: data }))));
};
export default DailyEarnings;
